import * as React from "react";
import { DatasheetFieldComponentTextAlign } from "@common/dto/datasheet/field-component/text-align";
import { DatasheetComponentTextStyle } from "@common/dto/datasheet/component-settings/text-style";

export type ContentValue = {
  fontFamily: string;
  fontSize: number;
  color: string;
  showBorder: boolean;
  showFieldType: boolean;
  styles: Array<DatasheetComponentTextStyle>;
  align?: DatasheetFieldComponentTextAlign;
  tabOrder: number;
};

export type ContentProps = {
  value: ContentValue;
  onChange: (value: ContentValue) => void;
};

export const useContentController = (props: ContentProps) => {
  const { onChange } = props;

  const handleChange = React.useCallback((value: Partial<ContentValue>) => {
    onChange({
      ...props.value,
      ...value,
    });
  }, [onChange, props.value]);

  const handleFontFamilyChange = React.useCallback((fontFamily: string) => {
    handleChange({ fontFamily });
  }, [handleChange]);

  const handleFontSizeChange = React.useCallback((fontSize: number) => {
    handleChange({ fontSize });
  }, [handleChange]);

  const handleColorChange = React.useCallback((color: string) => {
    handleChange({ color });
  }, [handleChange]);

  const handleShowBorderChange = React.useCallback((showBorder: boolean) => {
    handleChange({ showBorder });
  }, [handleChange]);

  const handleShowFieldTypeChange = React.useCallback((showFieldType: boolean) => {
    handleChange({ showFieldType });
  }, [handleChange]);

  const handleStylesChange = React.useCallback((styles: Array<DatasheetComponentTextStyle>) => {
    handleChange({ styles });
  }, [handleChange]);

  const handleAlignChange = React.useCallback((align: DatasheetFieldComponentTextAlign) => {
    handleChange({ align });
  }, [handleChange]);

  const handleTabOrderChange = React.useCallback((tabOrder: number) => {
    handleChange({ tabOrder });
  }, [handleChange]);

  return {
    handleFontFamilyChange,
    handleFontSizeChange,
    handleColorChange,
    handleShowBorderChange,
    handleShowFieldTypeChange,
    handleStylesChange,
    handleAlignChange,
    handleTabOrderChange,
  };
};